import React from 'react';
import { Phone, Mail } from 'lucide-react';
export function Header() {
  return <header className="w-full bg-white/95 backdrop-blur-sm sticky top-0 z-50 border-b border-gray-100 shadow-sm" data-id="element-180">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-181">
        <div className="flex justify-between items-center h-20" data-id="element-182">
          <div className="flex flex-col" data-id="element-183">
            <span className="font-serif text-2xl font-semibold text-gray-900 tracking-tight" data-id="element-184">
              Kareem Jamal
            </span>
            <span className="text-[10px] tracking-widest text-gray-500 uppercase font-medium" data-id="element-185">
              Rodeo Realty Fine Estates | DRE #00951359 | Kareem Jamal DRE
              #01998956
            </span>
          </div>

          <div className="hidden md:flex items-center space-x-8" data-id="element-186">
            <a href="#market-stats" className="text-sm font-medium text-gray-600 hover:text-brand-gold transition-colors" data-id="element-187">
              91311 Market
            </a>
            <a href="#about" className="text-sm font-medium text-gray-600 hover:text-brand-gold transition-colors" data-id="element-188">
              About Kareem
            </a>
            <div className="flex items-center space-x-4" data-id="element-189">
              <div className="flex flex-col items-end" data-id="element-190">
                <a href="tel:805-422-5488" className="flex items-center text-sm font-medium text-gray-600 hover:text-brand-gold transition-colors" data-id="element-191">
                  <Phone className="w-4 h-4 mr-2" data-id="element-192" />
                  805-422-5488
                </a>
                <span className="text-[10px] text-gray-400 mt-0.5" data-id="element-193">
                  Text for faster response
                </span>
              </div>
              <a href="#lead-form" className="bg-brand-gold hover-bg-brand-gold-dark text-white px-6 py-2.5 rounded-full text-sm font-medium transition-colors shadow-sm" data-id="element-194">
                Get Home Value
              </a>
              <a href="/admin" className="text-xs font-medium text-gray-400 hover:text-gray-600 transition-colors ml-4 border border-gray-200 rounded-full px-3 py-1" title="Admin Dashboard" data-id="element-195">
                Admin
              </a>
            </div>
          </div>
        </div>
      </div>
    </header>;
}